export interface Credentials {
  clientAccessId: string;
  jwt: string | null;
}
